export default "__VITE_ASSET__c899d4f1__"